export default __webpack_public_path__ + "a947bf020b26ea85daa17dfd2a1a17e902ab18ff/953bf272c7159fa44f34a644a31a09c9.png";